// extracted by mini-css-extract-plugin
export default {"container":"autocomplete_container__LLI9y","input-container":"autocomplete_input-container__3EORn","icon-position":"autocomplete_icon-position__UemIW"};